module.exports = __webpack_public_path__ + "img/upload-file-lock.a9f83422.svg";